import React from 'react';
import { Users, Trophy, Lightbulb, Target } from 'lucide-react';

const About = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h2 className="text-4xl font-bold text-gray-900">
                Sobre <span className="text-blue-600">Nosotros</span>
              </h2>
              <div className="space-y-4">
                <p className="text-lg text-gray-600 leading-relaxed">
                  Con más de <strong>30 años en el mercado</strong>, ModeloSmart se ha consolidado 
                  como líder en desarrollo de soluciones tecnológicas innovadoras. Comenzamos 
                  especializándonos en procesos de fabricación y herramientas administrativas, 
                  evolucionando hacia las tecnologías más avanzadas del mercado.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Hoy integramos inteligencia artificial, automatización con N8N, APIs personalizadas 
                  y las últimas tendencias tecnológicas para crear soluciones que realmente 
                  transforman negocios. Nuestro enfoque está orientado a resultados medibles 
                  y al crecimiento sostenible de nuestros clientes.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Cada proyecto es una oportunidad para aplicar décadas de experiencia combinada 
                  con innovación de vanguardia, garantizando soluciones robustas, escalables y 
                  alineadas con los objetivos de negocio de cada cliente.
                </p>
              </div>
            </div>

            {/* Key Features */}
            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Trophy className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">30+ Años</div>
                  <div className="text-sm text-gray-600">En el mercado</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                  <Lightbulb className="h-6 w-6 text-teal-600" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Innovación</div>
                  <div className="text-sm text-gray-600">Tecnologías IA</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                  <Target className="h-6 w-6 text-orange-600" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Resultados</div>
                  <div className="text-sm text-gray-600">Orientados</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                  <Users className="h-6 w-6 text-purple-600" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Experiencia</div>
                  <div className="text-sm text-gray-600">Multisectorial</div>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Equipo de desarrollo tecnológico"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 to-transparent rounded-2xl"></div>
            </div>
            
            {/* Background decoration */}
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-gradient-to-br from-blue-200 to-teal-200 rounded-2xl -z-10"></div>
            <div className="absolute -bottom-4 -left-4 w-72 h-72 bg-gradient-to-tr from-orange-200 to-purple-200 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;